import { Form as AntForm, FormItemProps, FormProps } from 'antd';

import { BFC } from '@/shared/types';

export const Form: BFC<FormProps> = (props) => {
  return <AntForm {...props} />;
};

export const FormItem: BFC<FormItemProps> = (props) => {
  return <AntForm.Item {...props} />;
};
